import React, {useState} from 'react';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Link,
  Typography,
} from '@mui/material';
import {DialogTitle} from '@apps-common/ui-components';
import {
  MESSAGES_KEYS,
  setValue as setMessageSeen,
} from '@app/util/local-messages';
import {Trans, useTranslation} from 'react-i18next';
import {bool, func} from 'prop-types';

const PostQuotaReservationModal = ({open, onClose}) => {
  const {t} = useTranslation();
  const [checked, setCheckbox] = useState(false);
  const handleClose = () => {
    if (checked) {
      setMessageSeen(MESSAGES_KEYS.POST_QUOTA_MESSAGE, true);
    }
    onClose();
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle
        title={t('postQuotaReservationModal.title')}
        onClose={onClose}
      />
      <DialogContent>
        <Typography gutterBottom>
          {t('postQuotaReservationModal.desc1')}
        </Typography>
        <Typography gutterBottom>
          <Trans
            i18nKey="postQuotaReservationModal.desc2"
            components={{
              linkTag: (
                <Link
                  color="inherit"
                  href="https://planetlabs.slack.com/archives/C05DJ62D3CM"
                  target="_blank"
                  rel="noreferrer noopener"
                ></Link>
              ),
            }}
          ></Trans>
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginX: 2,
          marginBottom: 1,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox checked={checked} onClick={() => setCheckbox(!checked)} />
          }
          label={
            <Typography variant="caption">
              {t('common:noShowCheckboxLabel')}
            </Typography>
          }
        />
        <Button color="primary" variant="contained" onClick={handleClose}>
          {t('postQuotaReservationModal.finishBtn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PostQuotaReservationModal.propTypes = {
  open: bool,
  onClose: func,
};

export default PostQuotaReservationModal;
